export default __webpack_public_path__ + "static/media/icon.thermographic camera.542a24bc.svg";